(function () {
  function getResponsiveVideoSource(videoEl, mobileAttr, desktopAttr) {
    if (!videoEl) return "";

    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const mobileSrc = videoEl.getAttribute(mobileAttr);
    const desktopSrc = videoEl.getAttribute(desktopAttr);

    return isMobile && mobileSrc ? mobileSrc : desktopSrc || mobileSrc || "";
  }

  function setVideoSource(videoEl, mobileAttr, desktopAttr) {
    if (!videoEl) return;

    const nextSrc = getResponsiveVideoSource(videoEl, mobileAttr, desktopAttr);
    if (!nextSrc) return;
    if (videoEl.getAttribute("src") === nextSrc) return;

    const wasPlaying = !videoEl.paused && !videoEl.ended && videoEl.readyState > 2;
    videoEl.setAttribute("src", nextSrc);
    videoEl.load();

    if (wasPlaying) {
      const playPromise = videoEl.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }
  }

  function initHeroMedia(section) {
    if (!section || section.dataset.tpHeroMediaInitialized === "true") return;
    section.dataset.tpHeroMediaInitialized = "true";

    const autoplayEnabled = section.dataset.autoplayVideo === "true";
    const previewVideo = section.querySelector("[data-preview-video]");
    const soundToggle = section.querySelector("[data-sound-toggle]");
    const modal = section.querySelector("[data-video-modal]");
    const modalVideo = section.querySelector("[data-modal-video]");
    const openBtn = section.querySelector("[data-video-modal-open]");
    const closeBtns = section.querySelectorAll("[data-video-modal-close]");

    function setupPreviewVideo() {
      if (!previewVideo) return;

      const nextSrc = getResponsiveVideoSource(
        previewVideo,
        "data-mobile-video",
        "data-desktop-video"
      );

      if (!nextSrc) return;
      if (previewVideo.getAttribute("src") === nextSrc) return;

      previewVideo.setAttribute("src", nextSrc);
      previewVideo.load();

      if (autoplayEnabled) {
        const playPromise = previewVideo.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }
    }

    function setupModalVideo() {
      if (!modalVideo) return;
      setVideoSource(
        modalVideo,
        "data-mobile-full-video",
        "data-desktop-full-video"
      );
    }

    function openModal() {
      if (!modal || !modalVideo) return;

      setupModalVideo();
      modal.hidden = false;
      document.documentElement.style.overflow = "hidden";

      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    }

    function closeModal() {
      if (!modal || !modalVideo) return;

      modalVideo.pause();
      modal.hidden = true;
      document.documentElement.style.overflow = "";
    }

    setupPreviewVideo();

    if (previewVideo && soundToggle) {
      soundToggle.addEventListener("click", function () {
        previewVideo.muted = !previewVideo.muted;
        soundToggle.classList.toggle("is-unmuted", !previewVideo.muted);
      });
    }

    if (openBtn) {
      openBtn.addEventListener("click", openModal);
    }

    if (closeBtns.length) {
      closeBtns.forEach(function (btn) {
        btn.addEventListener("click", closeModal);
      });
    }

    section.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) {
        closeModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal && !modal.hidden) {
        closeModal();
      }
    });

    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setupPreviewVideo();

        if (modal && !modal.hidden && modalVideo) {
          const wasPlaying = !modalVideo.paused;
          setupModalVideo();

          if (wasPlaying) {
            const playPromise = modalVideo.play();
            if (playPromise && typeof playPromise.catch === "function") {
              playPromise.catch(function () {});
            }
          }
        }
      }, 150);
    });
  }

  function initAllHeroMedia() {
    const sections = document.querySelectorAll("[data-tp-hero-media]");
    sections.forEach(initHeroMedia);
  }

  document.addEventListener("DOMContentLoaded", initAllHeroMedia);
  document.addEventListener("shopify:section:load", initAllHeroMedia);
  document.addEventListener("shopify:section:reorder", initAllHeroMedia);
})();